<template>
    <tis-button
        class="btn-gold block text-sm cursor-pointer"
        :url="url"
        :full-redirect="fullRedirect"
        :target="target"
        :title="title"
    >
        {{ text }}
        <svg-icon
            icon="arrow-horizontal"
            class="w-7 h-6 inline-block ml-3" />
    </tis-button>
</template>

<script>
import TisButton from '@whisper/components/buttons/TisButton';
import SvgIcon from '@whisper/components/icons/SvgIcon';

export default {
  components: {
    TisButton,
    SvgIcon,
  },
  props: ['url', 'target', 'text', 'fullRedirect', 'title'],
};
</script>
